import { FC } from 'react';

import cn from 'classnames';

import styles from '@/components/RegistrationForm/styles.module.scss';

type Props = {
	error: string;
	companyName: string;
	loading: boolean;
};
export const FnsField: FC<Props> = ({ companyName, error, loading }) => {
	if (!companyName && !error) return null;

	return (
		<div
			className={cn(styles.labelDescription, {
				[styles.innDataError]: !!error,
				[styles.isLoadingINN]: loading,
			})}
		>
			{error || companyName}
		</div>
	);
};
